var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSchoolDays(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1051",
    "data-name": "Rectangle 1051",
    width: 39.279,
    height: 35.501,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_school_days",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(334.193 222.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184-2",
    "data-name": "Group 184",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21764",
    "data-name": "Path 21764",
    d: "M.857,17.135A17.047,17.047,0,1,1,17.9,34.184,17.048,17.048,0,0,1,.857,17.135",
    transform: "translate(1.736 0.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21765",
    "data-name": "Path 21765",
    d: "M19.64,15.738c-9.521,0-19.641-2.1-19.641-6s10.12-6,19.641-6,19.641,2.1,19.641,6-10.12,6-19.641,6m0-10.529C8.383,5.209,1.472,7.848,1.472,9.738s6.91,4.529,18.168,4.529,18.171-2.638,18.171-4.529S30.9,5.209,19.64,5.209",
    transform: "translate(-0.002 7.572)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21766",
    "data-name": "Path 21766",
    d: "M22.625,34.631c-1.476,0-3.4-1.135-5.67-3.355A52.88,52.88,0,0,1,8.814,20.314,52.846,52.846,0,0,1,3.389,7.78c-1.029-4-.75-6.58.8-7.476C7.57-1.638,14.447,6.068,19.209,14.312a52.737,52.737,0,0,1,5.422,12.531c1.029,4,.753,6.58-.8,7.479a2.389,2.389,0,0,1-1.207.309M5.428,1.457a.98.98,0,0,0-.5.121c-.678.39-1.065,2.13-.112,5.836a51.421,51.421,0,0,0,5.273,12.165,51.373,51.373,0,0,0,7.9,10.647c2.729,2.678,4.432,3.213,5.11,2.82s1.065-2.13.109-5.836a51.135,51.135,0,0,0-5.27-12.162C12.783,6.122,7.537,1.457,5.428,1.457",
    transform: "translate(5.63 0.001)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21767",
    "data-name": "Path 21767",
    d: "M5.4,34.632a2.372,2.372,0,0,1-1.21-.312c-1.552-.9-1.827-3.482-.8-7.476A52.861,52.861,0,0,1,8.812,14.313C13.574,6.066,20.46-1.646,23.831.306c1.552.9,1.83,3.479.8,7.476a52.951,52.951,0,0,1-5.425,12.534,52.8,52.8,0,0,1-8.141,10.961C8.8,33.495,6.876,34.632,5.4,34.632M22.593,1.458c-2.106,0-7.355,4.665-12.507,13.59a51.258,51.258,0,0,0-5.27,12.162c-.956,3.7-.569,5.443.112,5.836s2.378-.142,5.11-2.82a51.478,51.478,0,0,0,7.9-10.647A51.4,51.4,0,0,0,23.207,7.415c.953-3.706.566-5.446-.112-5.836a.98.98,0,0,0-.5-.121",
    transform: "translate(5.631 -0.001)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21768",
    "data-name": "Path 21768",
    d: "M5.722,7.371A2.463,2.463,0,1,1,8.185,9.833,2.463,2.463,0,0,1,5.722,7.371",
    transform: "translate(11.59 9.94)",
    fill: "#4b89c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21769",
    "data-name": "Path 21769",
    d: "M8.677,11.062a3.2,3.2,0,1,1,3.2-3.2,3.2,3.2,0,0,1-3.2,3.2m0-4.925A1.726,1.726,0,1,0,10.4,7.864,1.729,1.729,0,0,0,8.677,6.136",
    transform: "translate(11.097 9.45)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21770",
    "data-name": "Path 21770",
    d: "M4.383,2.736A2.463,2.463,0,1,1,6.846,5.2,2.463,2.463,0,0,1,4.383,2.736",
    transform: "translate(8.878 0.552)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21771",
    "data-name": "Path 21771",
    d: "M7.338,6.426a3.2,3.2,0,1,1,3.2-3.2,3.2,3.2,0,0,1-3.2,3.2m0-4.925A1.728,1.728,0,1,0,9.062,3.228,1.729,1.729,0,0,0,7.338,1.5",
    transform: "translate(8.385 0.06)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21772",
    "data-name": "Path 21772",
    d: "M10.5,6.211a2.463,2.463,0,1,1,2.463,2.463A2.463,2.463,0,0,1,10.5,6.211",
    transform: "translate(21.263 7.59)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21773",
    "data-name": "Path 21773",
    d: "M13.453,9.9a3.2,3.2,0,1,1,3.2-3.2,3.2,3.2,0,0,1-3.2,3.2m0-4.925A1.728,1.728,0,1,0,15.18,6.7a1.729,1.729,0,0,0-1.728-1.728",
    transform: "translate(20.771 7.098)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21774",
    "data-name": "Path 21774",
    d: "M4.16,12.326a2.463,2.463,0,1,1,2.463,2.463A2.465,2.465,0,0,1,4.16,12.326",
    transform: "translate(8.426 19.976)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21775",
    "data-name": "Path 21775",
    d: "M7.115,16.018a3.2,3.2,0,1,1,3.2-3.2,3.2,3.2,0,0,1-3.2,3.2m0-4.928a1.729,1.729,0,1,0,1.728,1.728,1.729,1.729,0,0,0-1.728-1.728",
    transform: "translate(7.934 19.482)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSchoolDays);
export default __webpack_public_path__ + "static/media/ic_school_days.e53e32f2c1dce2dabfd8dc33e9ccc779.svg";
export { ForwardRef as ReactComponent };